import Ripple from 'vue-ripple-directive'
import { alphanumeric } from '@/mixins/alphanumeric'

export default {

  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  props: {
    status: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },

}
